export const PROFESSIONAL_PLUS_RATE = 1
export const CENTER_PLUS_RATE = 2
export const FLAT_RATE_WRITTEN_CONSULTATION = 3
export const INDIVIDUAL_FLAT_RATE = 4
export const OPENSALUDPASS_PREMIUM = 5
export const OPENSALUDPASS = 6
export const OPENSALUD_PRIME = 7
export const BASIC_RATE = 8
export const WELLNESS_PACK = 9
export const OPENSALUD_PRIME_SINGLE = 10
export const LAWYER_PLUS_RATE = 11


// WEBPACK FOOTER //
// ./src/constants/db/subscriptionTypes.js